import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Menu,
  MenuItem,
  Fab,
  Grid,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import api from '../../api/api';
import CreateEditUserDialog from './CreateEditUserDialog';

const PAGE_SIZE = 5;
const UserListingPage = () => {

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [dialogType, setDialogType] = useState('add'); // 'add' or 'edit'

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await api.get('/api/Users');
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching users', error);
    } finally {
      setLoading(false);
    }
  };


  const handleOpenDialog = (type,user = null) => {
    setDialogType(type);
    setCurrentUser(user);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCurrentUser(null);
  };

  const handleSaveUser = () => {
    fetchUsers();
  };

  const handleDeleteUser = async () => {
    try {
      await api.delete(`/api/Users/${currentUser.id}`);
      fetchUsers();
      handleCloseDialog();
    } catch (error) {
      console.error('Error deleting user', error);
    }
  };

  const handleMenuOpen = (event, user) => {
    setCurrentUser(user);
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography marginBottom={2} component="p" variant="h5">Users</Typography>
      {loading ? (
        <Typography>Loading...</Typography>
      ) : users.length === 0 ? (
        <Typography>No User Added.</Typography>
      ) : (
        <Grid container spacing={2}>
          {users.map((user) => (
            <Grid item xs={12} sm={6} md={4} key={user.id}>
              <Card>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography variant="h6">{user.name}</Typography>
                      <Typography variant="body2">Employee Code: {user.employeeCode}</Typography>
                      <Typography variant="body2">Email: {user.email}</Typography>
                      <Typography variant="body2">Department: {user.department.name}</Typography>
                      <Typography variant="body2">Role: {user.role.name}</Typography>
                    </Box>
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={(event) => handleMenuOpen(event, user)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => {
          handleOpenDialog('edit', currentUser);
          handleMenuClose();
        }}>Edit</MenuItem>
        <MenuItem onClick={() => {
          handleOpenDialog('delete', currentUser);
          handleMenuClose();
        }}>Delete</MenuItem>
      </Menu>
      <Fab color="primary" aria-label="add" sx={{ position: 'fixed', bottom: 16, right: 16 }} onClick={() => handleOpenDialog('add')}>
        <AddIcon />
      </Fab>
      {(dialogType === 'add' || dialogType === 'edit') && (
        <CreateEditUserDialog open={openDialog} handleClose={handleCloseDialog} user={currentUser} onSave={handleSaveUser}/>
      )}
      {dialogType === 'delete' && (
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <Typography>Are you sure you want to delete this user?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Cancel</Button>
            <Button onClick={handleDeleteUser} variant="contained" color="secondary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
};

export default UserListingPage;
